/**
 * Configuraciones comunes, no suele ser necesario reemplazarlas
 * Si es necesario modificar alguna de estas configuraciones, hacerlo en environment.custom.ts
 */

export const common = {
  // otros enlaces
  brandNameLink: 'https://vivofacil.com',
  serviceChat: 'https://asistencia.vivofacil.com',
  videoCallsUrl: 'https://videollamada.vivofacil.com/?kid=AljJRe39SLEsWhMFg2pqTrA',
  complaintsChannel: 'https://vivofacil.com/es/content/24-canal-de-denuncias',
  veterinaryVideoCallsUrl: 'https://calendly.com/vivofacil/videoconsulta-veterinaria',
  veterinaryChat: 'https://widget-page.smartsupp.com/widget/b16a399a78a713e02ac2fd696824ab65bdd1ad7c',


  /**
   * Debe existir la cadena de traducción de cada item
   */
  protectedPeople: {
    empleado: 'protectedPeople.employee',
    pareja: 'protectedPeople.partner',
    hijos: 'protectedPeople.offspring',
    padres: 'protectedPeople.parents',
    suegros: 'protectedPeople.inlaws'
  },

  /**
   * Valor por defecto utilizado cuando el usuario no tiene que introducir contraseña
   */
  defaultPassword: '',

  /**
    * Recaptcha en formularios
    * Si los formularios van protegidos con recaptcha sobreescribir esta variable
    * dándole el valor de la clave pública
    * Valores: false|<clave_publica>
  */
  recaptcha: false,

  /** Se agrupan los servicios por categorías */
  groupByCategories: true,

  /** Enlace adicional ubicado en top menu */
  externalTopLink: {
    /** Enlace habilitado o deshabilitado */
    status: false,
    /** Titulo del enlace */
    title: 'Link externo',
    /** URL del enlace */
    url: 'https://vivofacil.com',
    /** Se añade la cadena `/xxxxx` a la url, donde xxxxx es el identificador del usuario en base64 */
    concatIdentifier: true
  },

  /** Se permiten contraseñas no seguras */
  allowInsecurePasswords: true,

  /** numero de telefono o false. Si es false no se muestra el icono de whatsapp en las páginas */
  whatsapp: false,

  /** true of false. Define si se muestra el botón para volver al inicio */
  homeButton: false,

  /**
   * Api Key de Google Maps
   * Valores: false|<clave_publica>
   */
  googleMapsApiKey: false,

  /** Área privada **/
  showPrivateArea: true,

  /** true o false. Define si se activa DragonPass */
  dragonpassEnabled: false,

  /** Datos eSIM para descontar stock
   * min: número de días mínimo del rango
   * max: número de días máximo del rango
   * value: stock a descontar
   */
  esimRanges: [
    {min: 1, max: 7, value: 1},
    {min: 8, max: 14, value: 2},
    {min: 15, max: 21, value: 3},
    {min: 22, max: 28, value: 4}
  ],

  /** document type values (keys got from PDS, values from cms): {
    1: "NIF",
    2: "NIF intracomunitario",
    3: "Pasaporte (keys got from PDS)",
    4: "Documento oficial",
    5: "Certificado de residencia fiscal",
    6: "Otros",
    7: "Sin registrar"
  },*/
  /** If empty, not validate document type and value is 6 (otros) */
  /** Example: documentTypes: [1, 3], */
  documentTypes: [],
  validateDocumentType: false,

  /**
   * País por defecto en el registro de usuarios
   */
  // TODO: Obtener de api
  defaultCountryCode: 'ES',
  defaultCountryName: 'España', // TODO: Obtener de Google Maps API

  /**
   * Campos adicionales en el registro de usuarios
   */
  // TODO: Obtener de api
  /* Formato:
  additionalRegisterFields: {
    telephone: {
      required: true
    },
    zipCode: {
      required: true
    },
    gender: {
      required: true
    },
    birthDate: {
      required: true
    }
  }, */
  additionalRegisterFields: {},

  /**
   * Registro de usuarios por token en la url
   */
  // TODO: Obtener de api
  registerByToken: false,

  /**
   * Permitir el registro de usuarios por formulario si el colectivo es por registro. (Si es false, no se muetra formulario de registro)
   */
  // TODO: Obtener de api
  allowRegisterByUser: true,

  /**
   * Mostrar canales de contacto en header público
   */
  showPublicContactChannels: true,

  /**
   * Mostrar canales de contacto en header privado
   */
  showPrivateContactChannels: true,

  /**
   * Mostrar canales de contacto en banner privado
   */
  showPrivateBannerContactChannels: true,

  /**
   * Comprobar a través del token si se ha loguerado alguna vez y si es asi oculta el apartado de registro
   */
  checkIsRegisterAlready: false,
  checkShowRegisterFormIfToken: false,

  /**
   * Comprobar si se ha loguerado alguna vez y si es asi oculta el apartado de registro y muestra enlace para volver a registrarse
   */
  showRegisterLinkInstead: false,

  /**
   * UUID del formulario de contacto público. Si es null no se asigna a ningún servicio del CMS
   */
  contactFormPublicUuid: null,

  /**
   * Habilitar validador de fecha límite
   */
  hasCutOffDateValidator: false,

  /**
   * IDP key for SSO SAML login (only for SP-Initiated strategy)
   */
  idpKey: ''
};
